import { ETheme, FluentProvider } from '@/dependencies';
import { PopoverSurface, PopoverSurfaceProps } from '@fluentui/react-components';


interface PopoverSurfaceCustomProps {
    rcName?: string;   
    theme?: ETheme;
}

const PopoverSurfaceCustom = (props: PopoverSurfaceCustomProps & PopoverSurfaceProps) => {
    return props.theme ? (
      <FluentProvider theme={props.theme}>
        <PopoverSurface {...props}></PopoverSurface>
      </FluentProvider>
    ) : (
      <PopoverSurface {...props}></PopoverSurface>
    );
};

export default PopoverSurfaceCustom;